import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

import ConNav from './conNav';
import IfengIntro from './ifengIntro';
import IfengIntroList from './ifengIntroList';
import IfengWuXian from './ifengWuXian';
import IfengWuXianList from './ifengWuXianList';
import IfengVideo from './ifengVideo';
import IfengVideoList from './ifengVideoList';

class Content extends React.PureComponent {
    // eslint-disable-next-line no-useless-constructor
    constructor() {
        super();
        this.conNavHeader = {
            navCenter: '产品服务',
            navRight: '凤凰新媒体',
        };
    }

    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.pageBody}>
                <div className={styles.page}>
                    <div className={styles.pageHead}>
                        <div className={styles.pageEnd}>
                            <div className={styles.myContent}>
                                <ConNav conNavHeader={this.conNavHeader} />
                                <Chip
                                    id="132863"
                                    type="static"
                                    title="IFENG介绍"
                                    groupName="IFENG介绍"
                                    content={content}>
                                    <IfengIntro />
                                </Chip>
                                <Chip
                                    id="132868"
                                    type="static"
                                    title="IFENG介绍右侧内容列表"
                                    groupName="IFENG介绍右侧内容列表"
                                    content={content}>
                                    <IfengIntroList />
                                </Chip>
                            </div>
                            <div className={styles.clear} />
                        </div>
                    </div>
                </div>
                <div className={styles.border} />
            </div>
        );
    }
}

export default Content;
